/* eslint-disable */
import createInstance from '../services/http';
import config from '@/const/config';
const { request } = createInstance(config.goodsBaseUrl);
export function buyer_creat_session(data, options) {
  return request({
    method: 'POST',
    url: '/api/zy-operate-call/1.0/buyer_creat_session',
    data,
    ...options
  });
}
export function send_goods_message(data, options) {
  return request({
    method: 'POST',
    url: '/api/zy-operate-call/1.0/send_goods_message',
    data,
    ...options
  });
}
